export default 
`██████████████████████████████████
█████████   ███████   ████████████
██████████████ ██ ████████████████
█████████   ████████   ███████████
█████████   ████████   ███████████
██████████████████████████████████
██████████████████████████████████
██████████████████████████████████
███████████          █████████████
██████████ ██████████ ████████████
██████████████████████████████████
██████████████████████████████████`